import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Forside from './pages/Forside';
import JegTilbyder from './pages/JegTilbyder';
import ServiceDetail from './pages/ServiceDetail';
import KunderneSiger from './pages/KunderneSiger';
import Galleri from './pages/Galleri';
import OmOs from './pages/OmOs';
import Kontakt from './pages/Kontakt';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <>
      {/* Scroll restoration on route change */}
      <ScrollToTop />

      <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900 antialiased selection:bg-emerald-600 selection:text-white">
        {/* Sticky Black Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/jeg-tilbyder" element={<JegTilbyder />} />
            <Route path="/jeg-tilbyder/:serviceId" element={<ServiceDetail />} />
            <Route path="/kunderne-siger" element={<KunderneSiger />} />
            <Route path="/galleri" element={<Galleri />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/kontakt" element={<Kontakt />} />
            
            {/* 403 Forbidden Route */}
            <Route path="/403" element={<Forbidden />} />
            
            {/* 404 Not Found Fallback */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Black Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
